import { BOAT_RACE_IMAGES, BOAT_RACE_REFERENCE_LINKS_ML } from './boatRacePostUtils';

const GALLERY_IMAGES = {
  heats: BOAT_RACE_IMAGES.heats,
  alleppey: BOAT_RACE_IMAGES.alleppey,
  aranmula: BOAT_RACE_IMAGES.aranmula,
};

/** തലവടി ചുണ്ടൻ — ചരിത്രം, വിജയങ്ങൾ, NTBR & CBL 2026 (മലയാളം) */
export const THALAVADY_CHUNDAN_MALAYALAM_POST = {
  id: 'featured-thalavady-chundan-malayalam',
  slug: 'thalavady-chundan-charithram-ntbr-cbl-2026-malayalam',
  title: 'തലവടി ചുണ്ടൻ: ചരിത്രം, വിജയങ്ങൾ & NTBR / CBL 2026 പ്രിവ്യൂ',
  excerpt:
    'കുതിരത്തലയുള്ള കേരളത്തിന്റെ ചുണ്ടൻ വള്ളം — 2023-ൽ ജനിച്ചു, നീരാറ്റുപുറം വിജയിച്ചു, 72-ാം നെഹ്‌റു ട്രോഫിയിലേക്കും ചാമ്പ്യൻസ് ബോട്ട് ലീഗിലേക്കും. ചരിത്രം, ക്ലബ് വിവരങ്ങൾ, ഫലങ്ങൾ ട്രാക്ക് ചെയ്യാനുള്ള ലിങ്കുകൾ.',
  publishedAt: '2026-08-13T18:00:00.000Z',
  coverImageUrl: BOAT_RACE_IMAGES.hero,
  authorName: 'Daily Sports Life',
  clubName: 'കേരള കായിക വാർത്താ ഡെസ്ക്',
  audience: 'മലയാളി പ്രേക്ഷകർ',
  blogCategory: 'boat-races',
  locale: 'ml',
  boatRaceTopic: 'thalavady-chundan',
  alternateSlug: 'thalavady-chundan-history-ntbr-cbl-2026',
  featured: true,
  component: 'WellnessGuideBlogArticle',
  theme: 'diet',
  relatedPostsTitle: 'ബന്ധപ്പെട്ട വള്ളംകളി ലേഖനങ്ങൾ',
  relatedPosts: [
    {
      slug: 'thalavady-chundan-history-ntbr-cbl-2026',
      title: 'Thalavady Chundan: History, Victories & NTBR / CBL 2026 (English)',
      blurb: 'ഇംഗ്ലീഷ് പതിപ്പ്.',
    },
    {
      slug: 'nehru-trophy-2026-chundan-vallam-malayalam',
      title: '72-ാം നെഹ്‌റു ട്രോഫി 2026: 22 ചുണ്ടൻ വള്ളങ്ങൾ, ക്ലബുകൾ, കാപ്റ്റൻമാർ',
      blurb: 'പൂർണ്ണ NTBR 2026 പട്ടികയും മത്സര ദിവസ ഗൈഡും.',
    },
    {
      slug: 'kerala-boat-race-nehru-trophy-ntbr-malayalam',
      title: 'കേരള വള്ളംകളി ഗൈഡ്: NTBR 2026 & നെഹ്‌റു ട്രോഫി ചരിത്രം',
      blurb: 'വള്ളംകളി പശ്ചാത്തലവും സന്ദർശകർക്കുള്ള നുറുങ്ങുകളും.',
    },
  ],
  referenceLinks: [
    {
      label: 'കേരള ടൂറിസം — തലവടി ചുണ്ടൻ പ്രൊഫൈൽ',
      url: 'https://www.keralatourism.org/champions-boat-league/snake-boats/thalavady-chundan',
    },
    {
      label: 'തലവടി ചുണ്ടൻ — Facebook',
      url: 'https://www.facebook.com/thalavadychundan/',
    },
    {
      label: 'തലവടി ചുണ്ടൻ — Instagram',
      url: 'https://www.instagram.com/thalavadychundan/',
    },
    {
      label: 'നെഹ്‌റു ട്രോഫി — രജിസ്റ്റർ ചെയ്ത വള്ളങ്ങൾ & ട്രാക്ക്',
      url: 'https://nehrutrophy.nic.in/pages-en-IN/track.php',
    },
    {
      label: 'ചാമ്പ്യൻസ് ബോട്ട് ലീഗ് — കേരള ടൂറിസം',
      url: 'https://www.keralatourism.org/champions-boat-league/',
    },
    ...BOAT_RACE_REFERENCE_LINKS_ML,
    {
      label: 'ഓണ്മനോരമ — NTBR 2026-ൽ 71 വള്ളങ്ങൾ',
      url: 'https://www.onmanorama.com/travel/kerala/2026/08/11/nehru-trophy-boat-race-71-boats-register-for-the-iconic-annual-regatta.html',
    },
    {
      label: 'രാഷ്ട്രദീപിക — തലവടി ചുണ്ടൻ അവതരണം',
      url: 'https://www.rashtradeepika.com/thalavadi-chundan-boat-race/',
    },
  ],
  sections: [
    {
      type: 'stats',
      ariaLabel: 'തലവടി ചുണ്ടൻ — സംക്ഷിപ്തം',
      items: [
        { value: '1 ജനു 2023', label: 'വള്ളം അവതരിപ്പിച്ചു' },
        { value: '127 അടി', label: 'നീളം — കുതിരത്തല മുൻഭാഗം' },
        { value: '97', label: 'ക്രൂ (വരികർ + അമരക്കാർ + പാട്ടുകാർ)' },
        { value: '22 ഓഗ 2026', label: '72-ാം NTBR — CBL ഉദ്ഘാടനം' },
      ],
    },
    {
      type: 'panel',
      title: 'ആറാംതമ്പുരാൻ — കുട്ടനാടിന്റെ കന്നി അങ്കം',
      paragraphs: [
        'കേരളത്തിന്റെ **വള്ളംകളി** കലണ്ടറിൽ ഓരോ ഗ്രാമവും ഒരു **ചുണ്ടൻ വള്ളം** സ്വപ്നം കാണുന്നു — നൂറ് ഹൃദയങ്ങൾ വെള്ളത്തിലേക്ക് കൊണ്ടുപോകുന്ന നീണ്ട സ്നേക്ക് ബോട്ട്. **തലവടി ചുണ്ടൻ** ആ പാരമ്പര്യത്തിലെ ഏറ്റവും പുതിയതും വ്യത്യസ്തവുമായ പേരുകളിൽ ഒന്നാണ്. **2023 ജനുവരി 1**-ന് അവതരിപ്പിച്ച ഈ വള്ളം ആലപ്പുഴ മുഴുവൻ **ആറാംതമ്പുരാൻ** എന്ന് അറിയപ്പെടുന്നു — തലവടിയുടെ ജീവിതകാലത്തിലെ ആറാമത്തെ ചുണ്ടൻ എന്നർത്ഥത്തിൽ.',
        'പരമ്പരാഗത പാമ്പിന്റെ തലക്ക്‌രി മുൻഭാഗമുള്ള ചുണ്ടനുകളിൽ നിന്ന് തലവടി വ്യത്യസ്തമാകുന്നത് അതിന്റെ മുൻഭാഗത്താണ്: **സബരിമല ശ്രീ അയ്യപ്പ ക്ഷേത്രത്തിൽ പ്രതിഷ്ഠിച്ച തേക്ക് കുതിര ശില്പം**. ഗ്രാമവാസികൾ ഇതിനെ വേഗതയുടെയും ഭംഗിയുടെയും ചിഹ്നമായി കാണുന്നു — മത്സരിക്കാനും **തലവടിയുടെയും മുകൾ കുട്ടനാടിന്റെയും** അഭിമാനം പുന്നമടയിലേക്ക് കൊണ്ടുപോകാനും നിർമ്മിച്ച വള്ളം.',
        'വള്ളം **തലവടി ടൗൺ ബോട്ട് ക്ലബ് (TTBC)**-ന്റെ സ്വത്താണ് — **150-ലധികം ഓഹരി ഉടമകൾ** (പ്രവാസികൾ ഉൾപ്പെടെ) ഉള്ള സമൂഹ ക്ലബ്. പ്രധാന മത്സരങ്ങളിൽ **കൈനകരി വില്ലേജ് ബോട്ട് ക്ലബ്** തലവടി ചുണ്ടനെ വരിക്കുന്നു — **നെഹ്‌റു ട്രോഫി ബോട്ട് റേസ് (NTBR)** ഉം **ചാമ്പ്യൻസ് ബോട്ട് ലീഗ് (CBL)** ഉം ഉൾപ്പെടെ.',
      ],
      chips: ['തലവടി', 'ആറാംതമ്പുരാൻ', 'കുതിരത്തല ചുണ്ടൻ', 'കുട്ടനാട്', 'TTBC'],
    },
    {
      type: 'imageGallery',
      title: 'കുട്ടനാട് വള്ളംകളി — ചിത്രങ്ങൾ',
      intro: 'Wikimedia Commons-ൽ നിന്നുള്ള യഥാർത്ഥ ചിത്രങ്ങൾ (CC BY-SA). തലവടി ചുണ്ടൻ ഇതേ പുന്നമട, പമ്പാ വെള്ളങ്ങളിൽ മത്സരിക്കുന്നു.',
      images: [
        {
          url: GALLERY_IMAGES.heats,
          alt: 'നെഹ്‌റു ട്രോഫി — പുന്നമടയിൽ ചുണ്ടൻ ഹീറ്റ്',
          caption: 'നെഹ്‌റു ട്രോഫി ബോട്ട് റേസ്, പുന്നമട — Varghesepunnamada / Wikimedia.',
        },
        {
          url: GALLERY_IMAGES.alleppey,
          alt: 'നെഹ്‌റു ട്രോഫി, ആലപ്പുഴ',
          caption: 'ആലപ്പുഴ കായലുകളിലെ വള്ളംകളി — Wikimedia Commons.',
        },
        {
          url: GALLERY_IMAGES.aranmula,
          alt: 'കേരള ചുണ്ടൻ വള്ളംകളി',
          caption: 'ചുണ്ടൻ വള്ളങ്ങൾ — Anoopkn / Wikimedia.',
        },
      ],
    },
    {
      type: 'panel',
      title: 'തലവടിയുടെയും ബോട്ട് ക്ലബിന്റെയും ചരിത്രം',
      paragraphs: [
        '**തലവടി** **ആലപ്പുഴ ജില്ലയിലെ മുകൾ കുട്ടനാട്** പഞ്ചായത്തിലെ ഒരു ഗ്രാമമാണ് — കനാലുകൾ റോഡുകളും വള്ളംകളി സാമൂഹിക കലണ്ടറുമായ ജലനിറഞ്ഞ ഭൂപ്രദേശം. പേരിന് രാജകീയ ഓർമ്മയുണ്ട്: **ചെമ്പകശേരി രാജവംശ** കാലത്ത് രാജാവ് അമ്പലപ്പുഴയിൽ നിന്ന് വേനൽ കൊട്ടാരത്തിലേക്ക് യാത്ര ചെയ്യുമ്പോൾ ആദ്യം ഈ ഗ്രാമത്തിൽ ആഘോഷ വെടിക്കെട്ട് (**വാദ്യം**) നടത്തി. **തല** (പ്രധാന) + **വാദ്യം** (വെടിക്കെട്ട്) = **തലവടി** — «ആദ്യ വെടിക്കെട്ട്.»',
        'തലവടി തലമുറകളോളം അയൽ ഗ്രാമങ്ങൾ — വീയപുരം, കൈനകരി, നീരാറ്റുപുറം — ചുണ്ടൻ വിജയങ്ങൾ ആഘോഷിക്കുന്നത് കണ്ട് സ്വന്തം സ്വപ്നം വളർത്തി. **ഉത്രാടം** ദിവസം **നീരാറ്റുപുറത്ത് നടക്കുന്ന പമ്പാ ബോട്ട് റേസ്** ഇരുപത്തഞ്ച് വർഷമായി പ്രാദേശിക ഉത്സവമാണ്. മത്സര ചുണ്ടൻ നിർമ്മിക്കുന്നത് അടുത്ത യുക്തിസഹമായ ഘട്ടമായിരുന്നു.',
        '**തലവടി ടൗൺ ബോട്ട് ക്ലബ്** വള്ളംകളി പ്രേമികളുടെ കൂട്ടായ്മയിൽ രൂപപ്പെട്ടു — തലവടി, വീയപുരം തെക്ക്/വടക്ക്, പുതന്തുരുത്ത്, വെങ്കിടച്ചിറ എന്നിവ ഉൾപ്പെടെ. **സാബു ആചാരി** (സാബു നാരായണൻ ആചാരി) എന്ന മൂത്തശാരി **അഞ്ജിലി** മരത്തിൽ 127 അടി നീളമുള്ള ഹൾ പാരമ്പര്യ കൈവേലയിൽ നിർമ്മിച്ചു. പ്രവാസികളും സ്ഥാനികരും ഫണ്ട് സംഭാവന ചെയ്തു; കുതിരത്തല ശില്പം സബരിമലയിൽ അനുഗ്രഹിച്ച ശേഷം വള്ളത്തിൽ സ്ഥാപിച്ചു.',
        '**2023 പുതുവർഷ ദിനം** തലവടി ചുണ്ടൻ ആദ്യമായി വെള്ളത്തിലിറങ്ങി. മാസങ്ങൾക്കുള്ളിൽ സംശയക്കാരെ തെളിവാക്കി.',
      ],
      chips: ['ചെമ്പകശേരി', 'നീരാറ്റുപുറം', 'സാബു ആചാരി', 'TTBC', 'മുകൾ കുട്ടനാട്'],
    },
    {
      type: 'table',
      title: 'തലവടി ചുണ്ടൻ — വിവരണം',
      headers: ['വിശദാംശം', 'വിവരം'],
      rows: [
        ['നീളം', '127 അടി (~39 മീ)'],
        ['വീതി', '5 അടി'],
        ['വരികർ', '83'],
        ['അമരക്കാർ', '5'],
        ['പാട്ടുകാർ / ഗായകർ', '9'],
        ['മൊത്തം ക്രൂ', '97'],
        ['മരം', 'അഞ്ജിലി ഹൾ; തേക്ക് കുതിര ശില്പം മുൻഭാഗത്ത്'],
        ['പ്രത്യേകത', 'കുതിരത്തല മുൻഭാഗം (സബരിമലയിൽ പ്രതിഷ്ഠ)'],
        ['അവതരണം', '2023 ജനുവരി 1'],
        ['നിർമ്മാതാവ്', 'സാബു ആചാരി'],
        ['ഉടമ', 'തലവടി ടൗൺ ബോട്ട് ക്ലബ് (TTBC)'],
        ['മത്സര ക്ലബ്', 'കൈനകരി വില്ലേജ് ബോട്ട് ക്ലബ്'],
        ['പ്രാദേശിക വിളിപ്പേര്', 'ആറാംതമ്പുരാൻ'],
        ['ഓഹരി ഉടമകൾ', '150+ സമൂഹാംഗങ്ങളും പ്രവാസികളും'],
      ],
    },
    {
      type: 'panel',
      title: 'വിജയങ്ങളും മത്സര ഫലങ്ങളും',
      paragraphs: [
        'തലവടി ചുണ്ടന്റെ ആദ്യ സീസൺ ശാന്തമായിരുന്നില്ല. **ആദ്യ വർഷം (2023)**-ൽ **നീരാറ്റുപുറം ബോട്ട് റേസ്** വിജയിച്ചു — തലവടി തന്നെ ദശകങ്ങളായി ആതിഥ്യം ചെയ്യുന്ന ഉത്രാടം മത്സരം. കേരള ടൂറിസത്തിന്റെ CBL പ്രൊഫൈൽ ഇതിനെ അവതരണ വർഷത്തിൽ **«കന്നി അങ്കം»** എന്ന് വിശേഷിപ്പിക്കുന്നു.',
        'അതിനുശേഷം തലവടി ആലപ്പുഴയുടെ മഴക്കാല കലണ്ടറിലുടനീളം മത്സരിച്ചു — പ്രാദേശിക ഹീറ്റുകൾ, CBL വേദികൾ, ഏറ്റവും വലിയ വേദി **പുന്നമട**. **71-ാം നെഹ്‌റു ട്രോഫി (2025 ഓഗസ്റ്റ് 30)**-ൽ കൈനകരി യുണൈറ്റഡ് ബോട്ട് ക്ലബ് തലവടി ചുണ്ടനെ **ഹീറ്റിൽ അഞ്ചാമതിടം** നേടിച്ചു — നാല് വള്ളം ഫൈനലിൽ നിന്ന് ഒരു സ്ഥാനം പുറത്ത്. **വീയപുരം ചുണ്ടൻ** 4:21.084-ൽ വിജയിച്ചു (*ടൈംസ് ഓഫ് ഇന്ത്യ*, 2025).',
        '2026-ൽ തലവടി ഔദ്യോഗിക എൻട്രി പട്ടികയിൽ തിരിച്ചെത്തി. **ഓണ്മനോരമ** **22 ചുണ്ടൻ** വള്ളങ്ങളുടെ പട്ടികയിൽ **തലവടി ചുണ്ടൻ (കൈനകരി വില്ലേജ് ബോട്ട് ക്ലബ്)** ഉൾപ്പെടുത്തി — **2026 ഓഗസ്റ്റ് 22**-ന് **72-ാം നെഹ്‌റു ട്രോഫി**. മുൻ NTBR രജിസ്ട്രേഷനിൽ **പത്മകുമാർ പുതേൻപറമ്പിൽ**, **രാഹുൽ പ്രകാശ്** എന്നിവർ കോൺടാക്റ്റുകളായി.',
      ],
      list: [
        '**2023 — നീരാറ്റുപുറം ബോട്ട് റേസ്:** വിജയി (അവതരണ വർഷത്തിലെ മുഖ്യ നേട്ടം).',
        '**2024–2025 — NTBR & CBL:** പുന്നമടയിൽ മത്സരിച്ചു; 2025 ഹീറ്റിൽ 5-ാം സ്ഥാനം (ഫൈനലിൽ നിന്ന് ഒരു സ്ഥാനം പുറത്ത്).',
        '**2026 — NTBR #22:** 72-ാം നെഹ്‌റു ട്രോഫിക്ക് രജിസ്റ്റർ; CBL സീസൺ ആലപ്പുഴയിൽ തുടങ്ങുന്നു.',
      ],
      callout:
        'മത്സര വാരാന്ത്യങ്ങളിൽ [തലവടി ചുണ്ടൻ Facebook](https://www.facebook.com/thalavadychundan/) ഉം [Instagram](https://www.instagram.com/thalavadychundan/) ഉം പിന്തുടരുക.',
    },
    {
      type: 'panel',
      title: 'വരാനിരിക്കുന്നത്: 72-ാം നെഹ്‌റു ട്രോഫി & ചാമ്പ്യൻസ് ബോട്ട് ലീഗ് 2026',
      paragraphs: [
        '**72-ാം നെഹ്‌റു ട്രോഫി ബോട്ട് റേസ്** **2026 ഓഗസ്റ്റ് 22, ശനിയാഴ്ച** **ആലപ്പുഴ, പുന്നമടക്കായലിൽ** നടക്കും. തലവടി ചുണ്ടന് ഇത് സീസണിന്റെ നിർണായക പരീക്ഷ — 22 ചുണ്ടൻ വള്ളങ്ങൾ, ലക്ഷക്കണക്കിന് പ്രേക്ഷകർ, വിജയിക്കുന്ന ടീമിന് **₹25 ലക്ഷം** സമ്മാനം.',
        'NTBR **2026 ചാമ്പ്യൻസ് ബോട്ട് ലീഗിന്റെ (CBL)** ഉദ്ഘാടന വേദിയും കൂടിയാണ് — കേരള ടൂറിസത്തിന്റെ പ്രൊഫഷണൽ സ്നേക്ക് ബോട്ട് സർക്യൂട്ട് (സീസണുകളിൽ സ്റ്റാർ സ്പോർട്സ് ടെലികാസ്റ്റ്). NTBR-ന് ശേഷം CBL മത്സരങ്ങൾ ഓണം കാലത്ത് കേരളത്തിന്റെ കായലുകളിലുടനീളം. ക്ലബുകൾ പോയിന്റുകൾ നേടുന്നു; മൊത്തം ചാമ്പ്യൻ CBL ട്രോഫി; **പ്രസിഡന്റ്സ് ട്രോഫി** ഫൈനൽ സീസൺ അവസാനിപ്പിക്കുന്നു.',
        'കുട്ടനാടിന്റെ ക്ലബുകൾ **2026 ജൂലൈ** മുതൽ **റസിഡൻഷ്യൽ ട്രെയിനിംഗ് ക്യാമ്പുകൾ** ആരംഭിച്ചു — രാവിലെ/വൈകുന്നേരം വെപ്പ്, ഇരുട്ടുകുത്തി പരിശീലനം; ഓഗസ്റ്റ് ആദ്യം ഹൗസ്ബോട്ടുകൾ നീക്കിയ ശേഷം പൂർണ്ണ ചുണ്ടൻ പരിശീലനം. തലവടി ക്രൂ അവരിലും — നെഹ്‌റുവിന്റെ വെള്ളി ട്രോഫിക്ക് മത്സരിക്കുന്ന നാല് ഫൈനൽ സ്ലോട്ടുകൾ പിന്തുടരുന്നു.',
      ],
      orderedList: [
        '**NTBR തീയതി:** 2026 ഓഗസ്റ്റ് 22 (ശനിയാഴ്ച)',
        '**സ്ഥലം:** പുന്നമടക്കായല്‍, ആലപ്പുഴ (~1.4 കി.മീ ട്രാക്ക്)',
        '**തലവടി എൻട്രി:** 2026 രജിസ്ട്രേഷനിൽ ചുണ്ടൻ #1 (കൈനകരി വില്ലേജ് ബോട്ട് ക്ലബ്)',
        '**CBL:** സീസൺ NTBR-ൽ തുടങ്ങുന്നു; [കേരള ടൂറിസം CBL](https://www.keralatourism.org/champions-boat-league/) കലണ്ടർ പിന്തുടരുക',
        '**സമ്മാനം:** ₹25 ലക്ഷം വിജയി (NTBR ചുണ്ടൻ); CBL സീസൺ ചാമ്പ്യൻ ₹25 ലക്ഷം (2025 റഫറൻസ്)',
        '**ടിവി / സ്ട്രീമിംഗ്:** ഏഷ്യാനെറ്റ്, മനോരമ, ഡിഡി മലയാളം; CBL-ന് സ്റ്റാർ സ്പോർട്സ്',
      ],
    },
    {
      type: 'table',
      title: 'തലവടി ചുണ്ടൻ ട്രാക്ക് ചെയ്യാൻ — എൻട്രിയും ഫലങ്ങളും',
      intro: 'മത്സര ദിവസത്തിന് മുമ്പ് ഈ ലിങ്കുകൾ ബുക്ക്‌മാർക്ക് ചെയ്യുക. ഹീറ്റ് സമയവും ലേൻ ഡ്രോയും 22 ഓഗസ്റ്റിന് അടുത്ത് പ്രസിദ്ധീകരിക്കും.',
      headers: ['ഉറവിടം', 'എന്ത് ട്രാക്ക് ചെയ്യാം', 'ലിങ്ക്'],
      rows: [
        [
          'നെഹ്‌റു ട്രോഫി ഔദ്യോഗിക സൈറ്റ്',
          'രജിസ്റ്റർ ചെയ്ത വള്ളങ്ങൾ, ഹീറ്റ് ഷെഡ്യൂൾ, ലൈവ് ഫലങ്ങൾ',
          '[nehrutrophy.nic.in/track](https://nehrutrophy.nic.in/pages-en-IN/track.php)',
        ],
        [
          'NTBR ഓൺലൈൻ ടിക്കറ്റ്',
          'പുന്നമട മത്സര ദിവസ ഗാലറി പാസ്',
          '[nehrutrophy.nic.in/tickets](https://nehrutrophy.nic.in/pages-en-IN/online_ticket.php)',
        ],
        [
          'കേരള ടൂറിസം — തലവടി ചുണ്ടൻ',
          'വള്ളം പ്രൊഫൈൽ, CBL ഗാലറി',
          '[keralatourism.org/thalavady-chundan](https://www.keralatourism.org/champions-boat-league/snake-boats/thalavady-chundan)',
        ],
        [
          'ചാമ്പ്യൻസ് ബോട്ട് ലീഗ്',
          'CBL കലണ്ടർ, പോയിന്റ് ടേബിൾ',
          '[keralatourism.org/cbl](https://www.keralatourism.org/champions-boat-league/)',
        ],
        [
          'തലവടി ചുണ്ടൻ — Facebook',
          'പരിശീലന ഫോട്ടോകൾ, മത്സര ദിവസ അപ്ഡേറ്റുകൾ',
          '[facebook.com/thalavadychundan](https://www.facebook.com/thalavadychundan/)',
        ],
        [
          'തലവടി ചുണ്ടൻ — Instagram',
          'റീലുകൾ, ക്രൂ ഹൈലൈറ്റുകൾ, വിജയ ആഘോഷങ്ങൾ',
          '[instagram.com/thalavadychundan](https://www.instagram.com/thalavadychundan/)',
        ],
        [
          'ഓണ്മനോരമ — NTBR 2026',
          '22 ചുണ്ടൻ രജിസ്ട്രേഷൻ പട്ടിക',
          '[onmanorama.com NTBR 2026](https://www.onmanorama.com/travel/kerala/2026/08/11/nehru-trophy-boat-race-71-boats-register-for-the-iconic-annual-regatta.html)',
        ],
        [
          'ദി ഹിന്ദു — NTBR 2025 ഫലം',
          '2025 ഫൈനൽ: വീയപുരം വിജയം; തലവടി ഹീറ്റിൽ 5-ാം',
          '[thehindu.com NTBR 2025](https://www.thehindu.com/news/national/kerala/veeyapuram-chundan-lifts-nehru-trophy-in-photo-finish/article69993332.ece)',
        ],
      ],
    },
    {
      type: 'panel',
      title: 'നീരാറ്റുപുറം ബന്ധം',
      paragraphs: [
        'പുന്നമടയ്ക്ക് മുമ്പ് തലവടിയുടെ സ്വന്തം വെള്ളം **നീരാറ്റുപുറത്ത് പമ്പാ** ആണ്. **ഉത്രാടം** ദിവസം **പമ്പാ ബോട്ട് റേസ്** — ഇരുപത്തഞ്ച് വർഷവും കൂടി — ഗ്രാമ അഭിമാനവും ക്ഷേത്ര കാല ഉത്സവവും കൂടിക്കലരുന്നു. തലവടി ചുണ്ടന്റെ **2023 നീരാറ്റുപുറം വിജയം** ഒരു കായിക ഫലത്തിനപ്പുറം ആയിരുന്നു; വർഷങ്ങളായി മറ്റ് ചുണ്ടനുകൾ ട്രോഫി ഉയർത്തുന്നത് കണ്ട് കാത്തിരുന്ന ഗ്രാമത്തിന് ഉത്തരം.',
        'ഓരോ ഓഗസ്റ്റിലും പമ്പയും പുന്നമടയും രണ്ട് ഘട്ട നാടകമാണ്: പ്രാദേശിക മത്സരങ്ങൾ താളവും ക്രൂ ഐക്യവും നിർമ്മിക്കുന്നു; NTBR, CBL നിശ്ചയിക്കുന്നു കേരള കായിക ചരിത്രത്തിൽ ആര് പ്രവേശിക്കും. **ആറാംതമ്പുരന്റെ** ആരാധകർക്ക് രണ്ട് നദികളും പ്രധാനമാണ്.',
      ],
    },
    {
      type: 'panel',
      title: 'ഈ വള്ളം എന്തുകൊണ്ട് പ്രത്യേകം',
      paragraphs: [
        'കുട്ടനാടിൽ നിരവധി ചുണ്ടനുകൾ ഉണ്ട്, പക്ഷേ തലവടിയുടെ വേഗത്തിലുള്ള ഉയർച്ച പോലുള്ള കഥകൾ കുറവാണ്. സമൂഹം നിർമ്മിച്ച വള്ളം, 2023-ൽ അവതരിപ്പിച്ചു, **കരിച്ചൽ**, **നടുഭാഗം**, **ചമ്പക്കുളം** പോലുള്ള പുരാണങ്ങളുടെ അടുത്ത് NTBR എൻട്രി പട്ടികയിൽ. മറ്റുള്ളവ കോബ്ര തലക്ക്‌രി ധരിക്കുമ്പോൾ കുതിര. ഓഹരി ഉടമകൾ ഇന്നും **കരയോഗം** ആയി കൂടിക്കുന്ന ക്ലബ് — ഹൾ നന്നാക്കൽ മുതൽ മത്സര തന്ത്രം വരെ.',
        '2026 ഫൈനലിൽ പ്രവേശിക്കുകയോ മറ്റൊരു നീരാറ്റുപുറം കിരീടം നേടുകയോ ചെയ്താലും, വള്ളം നിർമ്മിക്കപ്പെട്ടത് ചെയ്യാനുള്ളതാണ്: തലവടിക്ക് വെള്ളത്തിൽ ഒരു പേര് നൽകുക. **നല്ല വരികൾ, നല്ല താളം — 22 ഓഗസ്റ്റ് ആറാംതമ്പുരാൻ വേഗത്തിൽ ഓടട്ടെ!**',
      ],
      chips: ['നീരാറ്റുപുറം', 'NTBR 2026', 'CBL', 'പുന്നമട', 'വള്ളംകളി'],
      callout: {
        text: 'NTBR ഹീറ്റുകളും ഫലങ്ങളും ട്രാക്ക് ചെയ്യുക →',
        url: 'https://nehrutrophy.nic.in/pages-en-IN/track.php',
      },
    },
  ],
};
